module.exports = __webpack_public_path__ + "img/poweredby.cdf627d2.svg";